import { getApiUrl } from 'shared-kernel/helpers';

export const baseReducers = {
    _set: (state, payload) => ({
        ...state,
        item: {
            ...state.item,
            [payload.name]: payload.value
        }
    }),
    requested: state => ({
        ...state,
        isFetching: true
    }),
    failed: state => ({
        ...state,
        isFetching: false,
        isFailed: true
    }),
    itemReceived: (state, payload) => ({
        ...state,
        isFetching: false,
        item: payload.data
    }),
    itemsReceived: (state, payload) => ({
        ...state,
        isFetching: false,
        items: payload.data.items,
        total: payload.data.total
    }),
    deleteReceived: state => ({
        ...state,
        isFetching: false
    }),
    submitReceived: state => ({
        ...state,
        isFetching: false
    })
}

export const getBaseActions = (requestType, failedType) => {
    const baseSet = (type, payload) => ({ type, payload });

    const baseGet = (controller, type, payload) => {
        return ({
            types: [requestType, type, failedType],
            url: getApiUrl(controller, 'get'),
            payload
        });
    }

    const baseGetAll = (controller, type, payload) => {
        return ({
            types: [requestType, type, failedType],
            url: getApiUrl(controller, 'getAll'),
            payload,
            method: 'post'
        });
    }

    const baseSubmit = (controller, type, payload, method = 'upload') => {
        return ({
            types: [requestType, type, failedType],
            url: getApiUrl(controller, 'submit'),
            payload,
            method
        });
    }

    const baseDelete = (controller, type, payload) => {
        return ({
            types: [requestType, type, failedType],
            url: getApiUrl(controller, 'delete'),
            payload,
            method: 'post'
        });
    }

    return { baseSet, baseGet, baseGetAll, baseSubmit, baseDelete };
}